/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum UiFeatureFlags {
    ui_2601_f_infra_dashboard_open_issues_trend = 'ui_2601_f_infra_dashboard_open_issues_trend',
    ui_2601_f_infra_dashboard_by_resource_category = 'ui_2601_f_infra_dashboard_by_resource_category',
    ui_2601_f_widget_filter_lazy_select = 'ui_2601_f_widget_filter_lazy_select',
    ui_2602_f_lazy_dropdown_select = 'ui_2602_f_lazy_dropdown_select',
    ui_2602_f_dimension_creation_wizard = 'ui_2602_f_dimension_creation_wizard',
    ui_2602_f_infra_dashboard_enable_workload_filter = 'ui_2602_f_infra_dashboard_enable_workload_filter',
    ui_2602_f_widget_lazy_sa = 'ui_2602_f_widget_lazy_sa',
    ui_2602_f_t2_data_time_range_presets = 'ui_2602_f_t2_data_time_range_presets',
    ui_2603_f_ai_observability_119985 = 'ui_2603_f_ai_observability_119985',
    ui_2603_f_remediation_explorer = 'ui_2603_f_remediation_explorer',
    ui_2605_f_azure_recommendations_source = 'ui_2605_f_azure_recommendations_source'
}
